import { render, staticRenderFns } from "./store-detail.vue?vue&type=template&id=ef4c0e2a&scoped=true&"
import script from "./store-detail.vue?vue&type=script&lang=js&"
export * from "./store-detail.vue?vue&type=script&lang=js&"
import style0 from "./store-detail.vue?vue&type=style&index=0&id=ef4c0e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4c0e2a",
  null
  
)

export default component.exports